// singleton module for managing the HotkeyRegistry instance

let hotkeyRegistry;

export const getHotkeyRegistry = () => {
  return hotkeyRegistry;
};

export const setHotkeyRegistry = newHotkeyRegistry => {
  hotkeyRegistry = newHotkeyRegistry;
};
